import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { reportWebVitals } from "@/lib/webVitals";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Fire Core Web Vitals telemetry after mount (prod-only, silent failures).
reportWebVitals();
